import { useContext } from "react";
import { useOptionalProviderAttachments } from "./useOptionalProviderAttachments";
import { LocalAttachmentsContext } from "./LocalAttachmentsContext";

export const usePromptInputAttachments = () => {
  // Dual-mode: prefer provider if present, otherwise use local
  const provider = useOptionalProviderAttachments();
  const local = useContext(LocalAttachmentsContext);
  const context = provider ?? local;
  if (!context) {
    throw new Error(
      "usePromptInputAttachments must be used within a PromptInput or PromptInputProvider"
    );
  }
  return context;
};
